const menu = {
  namespaced: true,
  state: {
    query: {
      clientId: 'platform'
    }
  },
  mutations: {
    SET_QUERY: function (state, query) {
      state.query = query
    }
  },
  actions: {},
  getters: {
    query: function (state) {
      return state.query
    }
  }
}
export default menu
